import React from "react";
import { COMPANY_INFO } from "@/lib/constants";
import SocialLinks from "./SocialLinks";
import CompanyLinks from "./CompanyLinks";
import LandingPagesLinks from "./LandingPagesLinks";
import ContactInfo from "./ContactInfo";
import LegalLinks from "./LegalLinks";

const Footer = () => {
  return (
    <footer className="bg-white border-t py-12">
      <div className="container px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div>
            <div className="flex items-center mb-4 gap-2">
              <img src="/icon.png" alt="Orcsys" className="w-8 h-8 mb-4" />
              <h3 className="text-lg font-semibold mb-4">
                {COMPANY_INFO.name}
              </h3>
            </div>
            <p className="text-gray-600 mb-4">
              Solutions logicielles innovantes pour entrepreneurs et startups.
            </p>
            <SocialLinks />
          </div>

          <CompanyLinks />
          <LandingPagesLinks />
          <LegalLinks />
          <ContactInfo />
        </div>

        <div className="mt-8 pt-8 border-t">
          <p className="text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} {COMPANY_INFO.name}. Tous droits
            réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
